import { useTranslation } from 'react-i18next'

import { useTravelDates } from '../../Hooks/dates/useTravelDates'
import { useThreeDots } from '../../Hooks/useThreeDots'

import { toDateString } from '../../Utils'

interface Props {
  children: React.ReactNode
  isLoading: boolean
  onClick: () => void
}

const OverlayFooter: React.FC<Props> = ({ children, isLoading }) => {
  const { t } = useTranslation()
  const { selectedHomeboundDate, selectedOutboundDate } = useTravelDates()
  const loadingDots = useThreeDots()

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 mt-auto flex h-[80px] min-h-[80px] justify-center border-0 border-t border-solid border-gray-300 bg-white px-semantic-global-md md:relative lg:hidden"
      id="footer-content"
    >
      <div className="flex w-full flex-col justify-center">
        <div className="flex flex-row items-center">{children}</div>
        <div className="flex flex-row items-center justify-center">
          <div className="flex w-1/2 flex-none flex-col items-center justify-center overflow-hidden px-semantic-global-md">
            <label className="text-xs text-semantic-global-text-light"> {t('OUTBOUND')}</label>
            {selectedOutboundDate ? (
              <div className="notranslate font-medium text-semantic-global-text-default" translate="no">
                {isLoading ? loadingDots : toDateString(selectedOutboundDate)}
              </div>
            ) : null}
            {!selectedOutboundDate ? <div className="font-medium text-semantic-global-text-default">-</div> : null}
          </div>
          <div className="h-[100%] border-0 border-l border-solid border-gray-300" />
          <div className="flex w-1/2 flex-none flex-col items-center justify-center overflow-hidden px-semantic-global-md">
            <label className="text-xs text-semantic-global-text-light">{t('INBOUND')}</label>
            {selectedHomeboundDate ? (
              <div className="notranslate font-medium text-semantic-global-text-default" translate="no">
                {isLoading ? loadingDots : toDateString(selectedHomeboundDate)}
              </div>
            ) : null}
            {!selectedHomeboundDate ? <div className="font-medium text-semantic-global-text-default">-</div> : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OverlayFooter
